import React, { useState } from 'react'
import {
    MuiBox,
    MuiDefaultModal,
    Button,
    GridItem,
    MuiTypography,
    MuiInput,
    GridContainer,
    MenuConvertIcon,
    formatBRCurrency,
} from '../../../../components/storybook'
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor'
import { Controller } from 'react-hook-form'
import { styleModalTransferValue } from '../../utils'
import { IconButton, InputAdornment } from '@mui/material'
import { Visibility, VisibilityOff } from '@material-ui/icons'
export function ModalTransferValue({
    isModalTransferOpen,
    setIsModalTransferOpen,
    watchFields,
    isSmallScreen,
    dataSimulatePointsConversion,
    handlePasswordSubmit,
    handleSubmit,
    control,
    isLoading,
    errors
}) {
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    return (
        <MuiDefaultModal
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={isModalTransferOpen}
            onClose={() => setIsModalTransferOpen(false)}
        >
            <MuiBox
                sx={{
                    ...styleModalTransferValue,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
            >
                <form onSubmit={handleSubmit(handlePasswordSubmit)}>
                    <GridContainer spacing={2}>
                        <GridItem xs={12} sm={12} md={12}>
                            <MenuConvertIcon size={55} color="#F8BB86" />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} mt={2}>
                            <MuiTypography
                                fontSize="14px"
                                fontWeight={600}
                                color={GetThemeColorFromStorage()?.titles?.highlight?.textColor || "#21409A"}
                            >
                                CONVERTER E ENVIAR O VALOR PARA A CARTEIRA DIGITAL
                            </MuiTypography>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} mb={2}>
                            <MuiTypography
                                fontWeight={600}
                                color={GetThemeColorFromStorage()?.titles?.highlight?.textColor || "#21409A"}
                            >
                                {dataSimulatePointsConversion?.liquidValue
                                    ? formatBRCurrency(
                                        dataSimulatePointsConversion?.liquidValue,
                                    )
                                    : '-'}
                            </MuiTypography>
                        </GridItem>{' '}
                        <GridItem xs={12} sm={12} md={12}>
                            <MuiTypography
                                color="#F05B4F"
                                fontWeight={600}
                                fontSize="14px"
                            >
                                Após realizar a operação não será possível fazer a reversão.
                            </MuiTypography>
                        </GridItem>{' '}
                        <GridItem xs={12} sm={12} md={12}>
                            <MuiTypography color="#333333" fontSize="14px">
                                Para prosseguir é necessário informar a sua
                                senha
                            </MuiTypography>
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={12}
                            md={12}
                            sx={{
                                padding: isSmallScreen
                                    ? 0
                                    : '0px 80px!important',
                                textAlign: 'left',
                            }}
                        >
                            <Controller
                                name="password"
                                control={control}
                                defaultValue=""
                                rules={{
                                    required: "Senha obrigatória"
                                }}
                                render={({ ...field }) => (
                                    <MuiInput
                                        {...field}
                                        placeholder="Senha *"
                                        standard
                                        showLabel
                                        textLabel={
                                            watchFields?.password
                                                ? 'Senha *'
                                                : ' '
                                        }
                                        defaultColor={
                                            GetThemeColorFromStorage()
                                                ?.navigation?.buttons
                                                ?.backgroundColor
                                        }
                                        error={!!errors.password}
                                        helperText={errors?.password?.message}
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        disableRipple
                                                        aria-label="toggle password visibility"
                                                        onClick={() =>
                                                            setShowConfirmPassword(
                                                                !showConfirmPassword,
                                                            )
                                                        }
                                                    >
                                                        {showConfirmPassword ? (
                                                            <Visibility />
                                                        ) : (
                                                            <VisibilityOff />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            sx={{
                                paddingLeft: isSmallScreen
                                    ? 0
                                    : '80px!important',
                            }}
                        >
                            <Button
                                borderColor={
                                    GetThemeColorFromStorage()?.navigation
                                        ?.buttons?.backgroundColor
                                }
                                defaultColor="transparent"
                                icon=""
                                outlined="outlined"
                                text="CANCELAR"
                                textColor={
                                    GetThemeColorFromStorage()?.navigation
                                        ?.buttons?.backgroundColor
                                }
                                typeVariation="CustomTextButton"
                                borderRadius="5px"
                                onClick={() => setIsModalTransferOpen(false)}
                            />
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            sx={{
                                paddingRight: isSmallScreen
                                    ? 0
                                    : '80px!important',
                            }}
                        >
                            <Button
                                defaultColor={
                                    GetThemeColorFromStorage()?.navigation
                                        ?.buttons?.backgroundColor
                                }
                                icon=""
                                outlined="outlined"
                                text="CONFIRMAR"
                                textColor="#FFFFFF"
                                typeVariation="CustomTextButton"
                                borderRadius="5px"
                                type="submit"
                                isLoading={isLoading}
                                loaderColor="#FFFFFF"
                                disabled={isLoading}
                            />
                        </GridItem>
                    </GridContainer>
                </form>
            </MuiBox>
        </MuiDefaultModal>
    )
}
